// @ts-nocheck
/* eslint-disable */
import SceneGeometry from "./geometry";
import SceneCoords from "~/scene/common/coords";
import SceneGeometrySmart from "./smart";

export default class SceneGeometryMulti extends SceneGeometry {
	_geometries: Array<SceneGeometry | SceneGeometrySmart>;

	/**
	 * Vytvoreni multi geometrie - napr. data z lookupu.
	 *
	 * @param  {Object} data Vstupni data
	 */
	constructor(scene, itemId, data, options) {
		super(scene, itemId);

		this._data = data;
		this._geometries = [];
		this._source = "";
		this._plainId = 0;
		this._disableClick = false;

		if (this._data.extend && !this._data.extend.traffic) {
			this._data.extend.traffic = {
				load: 1
			};
		}

		this.setOptions(options);
		this._setFromData();
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		while (this._geometries.length) {
			this._geometries.pop().destroy();
		}
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneGeometryMulti",
			type: "geometry"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.options = this._options;
		rd.disabledClick = this._disableClick;

		return rd;
	}

	/**
	 * Zruseni poslouchani na klik geometrie.
	 */
	disableClick() {
		this._disableClick = true;

		this._onChange(this._scene.featureEvent("geometryMultiDisableClick", true, true), arguments);
	}

	/**
	 * Pridani geometrie.
	 *
	 * @param {SceneGeometry} geometry
	 */
	addGeometry(geometry) {
		this._geometries.push(geometry);
		this._countBBox();
	}

	/**
	 * Ziskani vsech geometrii.
	 *
	 * @return {Array[SceneGeometry]}
	 */
	getGeometries() {
		return this._geometries;
	}

	/**
	 * Odstraneni vsech geometrii.
	 */
	clear() {
		this._geometries.forEach(geometry => {
			geometry.clear();
		});
		this._countBBox();
	}

	/**
	 * Nastaveni ownera.
	 *
	 * @param {SceneFeature} owner Vlastnik
	 */
	setOwner(owner) {
		for (let i = 0; i < this._geometries.length; i++) { this._geometries[i].appended = !!owner; }

		super.setOwner(owner);
	}

	/**
	 * Spocitani stredu a zoomu geometrie.
	 *
	 * @param  {Boolean} [usePadding] Pouzit padding?
	 * @return {Array}
	 */
	computeCenterZoom(usePadding) {
		let coords = [];

		for (let i = 0; i < this._geometries.length; i++) {
			let gc = this._geometries[i].getCoords();

			for (let j=0;j<gc.length;j++) {
				let c = gc[j];

				if (!Array.isArray(c)) { c = [c]; }

				for (let k = 0; k < c.length; k++) {
					if (c[k] instanceof SceneCoords) { coords.push(c[k]); }
				}
			}
		}

		return this._scene.computeCenterZoom(coords, usePadding);
	}

	/**
	 * Geometrie - jedna se o oblast?
	 * @return {Boolean}
	 */
	isArea() {
		for (let i = 0; i < this._geometries.length; i++) {
			if (this._geometries[i].type != this._scene.GEOMETRY.POLYGON) { return false; }
		}

		return true;
	}

	/**
	 * Geometrie - jedna se o bod?
	 * @return {Boolean}
	 */
	isPoint() {
		for (let i = 0; i < this._geometries.length; i++) {
			if (this._geometries[i].type != this._scene.GEOMETRY.CIRCLE) { return false; }
		}

		return true;
	}

	/**
	 * Nastaveni zdroje.
	 *
	 * @param {String} source
	 */
	setSource(source) {
		this._source = source;
	}

	/**
	 * Ziskani zdroje.
	 *
	 * @return {String}
	 */
	getSource() {
		return this._source;
	}

	/**
	 * Nastaveni ID.
	 *
	 * @param {Number} plainId
	 */
	setPlainId(plainId) {
		this._plainId = plainId;
	}

	/**
	 * Ziskani ID.
	 *
	 * @return {Number}
	 */
	getPlainId() {
		return this._plainId;
	}

	/**
	 * Nastaveni geometrie z dat.
	 */
	_setFromData() {
		let options = this._optionsFromData();

		for (let key in options) {
			this._options[key] = options[key];
		}

		this._id = this._data.source + this._data.id;
		this._coords = [];

		this.setSource(this._data.source);
		this.setPlainId(this._data.id);

		let geometries = this._geometryFromData(options);

		if (!Array.isArray(geometries)) { geometries = [geometries]; }

		while (geometries.length) {
			this.addGeometry(geometries.shift());
		}
	}

	/**
	 * Ziskani options z dat.
	 *
	 * @return {Object}
	 */
	_optionsFromData() {
		let geom = this._data.geom;
		let result = {
			title: this._data.title
		};

		for (let p in geom.style) {
			if (p.match(/width|opacity/i)) {
				result[p] = parseFloat(geom.style[p]);
			}
			else {
				result[p] = geom.style[p];
			}
		}

		if (this._data.future) {
			result.color = "#aa00ff";
		}

		if (this._data.past) {
			result.color = "#ff9900";
		}

		return result;
	}

	/**
	 * Ziskani geometrie z dat.
	 *
	 * @param  {Object} options Konfigurace
	 * @return {Array]
	 */
	_geometryFromData(options) {
		let geom = this._data.geom;
		let result = [];

		switch (geom.type) {
			case "linestring":
			case "multilinestring":
				for (let i = 0; i < geom.data.length; i++) {
					let coords = this._scene.stringToCoords(geom.data[i]);

					result.push(this._scene.createGeometry(this._scene.GEOMETRY.POLYLINE, null, coords, options));
				}
			break;

			case "polygon":
				for (let i = 0; i < geom.data.length; i++) {
					let coords = this._scene.stringToCoords(geom.data[i]);

					result.push(this._scene.createGeometry(this._scene.GEOMETRY.POLYGON, null, coords, options));
				}
			break;

			case "multipolygon":
			case "path":
				let coords = [];

				for (let i = 0; i < geom.data.length; i++) {
					coords.push(this._scene.stringToCoords(geom.data[i]));
				}

				this.setCoords(coords);

				coords.length && result.push(this._scene.createGeometry(this._scene.GEOMETRY[geom.type === "path" ? "PATH" : "POLYGON"], null, coords, options));
			break;

			case "point":
				let center = this._scene.stringToCoords(geom.data[0])[0];

				result = this._scene.createGeometry(this._scene.GEOMETRY.CIRCLE, null, [center, options.width || 5], options);
				break;

			case "multipoint":
				geom.data.forEach(data => {
					let center = this._scene.stringToCoords(data)[0];

					result.push(this._scene.createGeometry(this._scene.GEOMETRY.CIRCLE, null, [center, options.width || 5], options));
				})
				break;

			default:
				throw new Error("Unknown geometry '"+geom.type+"'");
			break;
		}

		return result;
	}

	_countBBox() {
		let minX = Infinity;
		let minY = Infinity;
		let maxX = -Infinity;
		let maxY = -Infinity;

		this._bbox.min = null;
		this._bbox.max = null;
		this._bbox.empty = true;

		if (this._geometries && this._geometries.length) {
			for (const geom of this._geometries) {
				const bbox = geom.getBBoxWgs84();

				if (!bbox.empty) {
					minX = Math.min(bbox.min.x, minX);
					minY = Math.min(bbox.min.y, minY);
					maxX = Math.max(bbox.max.x, maxX);
					maxY = Math.max(bbox.max.x, maxY);
				}
			}
		}

		if (minX !== Infinity) {
			this._bbox.min = this._scene.coordsFromWGS84(minX, minY);
			this._bbox.max = this._scene.coordsFromWGS84(maxX, maxY);
			this._bbox.empty = false;
		}
	}
}
